<div class="page">
  <header class="page__header">
    <h1 class="page__title" i18n="@@sr_list.page.header.title">Service Requests</h1>
    <p-breadcrumb [home]="breadcrumbHome" [model]="breadcrumbItems"></p-breadcrumb>
  </header>
  <p-card class="page__content">
    <p-table [value]="serviceRequests.data" stripedRows>
      <ng-template pTemplate="caption">
        <carehub-service-request-list-filter
          [filterParams]="searchParams"
          (filterChange)="updateFilters($event)"></carehub-service-request-list-filter>
      </ng-template>
      <ng-template pTemplate="header">
        <tr carehub-table-header
          [config]="headerConfig"
          (sortingChange)="updateSorting($event)"></tr>
      </ng-template>
      <ng-template pTemplate="body" let-serviceRequest>
        <tr class="row">
          <td>
            {{ serviceRequest.id }}
          </td>
          <td
            [pTooltip]="serviceRequest.title"
            tooltipPosition="bottom"
            [tooltipDisabled]="serviceRequest.title.length < 50">
            {{ serviceRequest.title | truncate: 50 }}
          </td>
          <td>
            <p-tag
              class="row__status"
              [value]="serviceRequest.status"
              [styleClass]="'row__status--' + formatStatusLabel(serviceRequest.status)">
            </p-tag>
          </td>
          <td>{{ serviceRequest.requester }}</td>
          <td
            [ngClass]="{
              'row__assigned--unassigned': serviceRequest.assignedTo === 'Unassigned',
            }">
            {{ serviceRequest.assignedTo }}
          </td>
          <td>
            @if (serviceRequest.priority > 0) {
              <p-badge
                class="row__priority"
                [value]="serviceRequest.priority"
                [styleClass]="'row__priority--' + serviceRequest.priority" />
            }
          </td>
          <td>{{ serviceRequest.createdDate | date: 'dd/MM/yyyy' }}</td>
          <td class="row__actions">
            <p-button
              pTooltip="Join chat"
              i18n-pTooltip="@@common.button.join_chat"
              tooltipPosition="bottom"
              icon="pi pi-send"
              iconPos="right"
              [rounded]="true"
              [text]="true"
              size="small"
              (click)="startTeamsChat(serviceRequest)" />
            <a
              [routerLink]="['/utilities/service-requests/', serviceRequest.id]"
              class="p-button p-button-icon-only p-button-rounded p-button-text p-button-sm"
              pTooltip="View"
              i18n-pTooltip="@@common.button.edit"
              tooltipPosition="bottom"
              (click)="$event.stopPropagation()">
              <i class="pi pi-eye"></i>
            </a>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-paginator
      class="mt-2 align-self-end"
      (onPageChange)="changePage($event)"
      [first]="0"
      [rows]="50"
      [totalRecords]="serviceRequests.totalCount"></p-paginator>
  </p-card>
</div>
